export const getExtensionFromFileName = (
  fileName: string,
): string | undefined => fileName.split(".").pop();
